module.exports = __webpack_public_path__ + "85ec024a9529e151a8545bef215b3a87.png";